// FieldsDialog.js
// "View" on a unit that is not ingested (Spec 2 section 6.5): its row's fields
// and values, read-only. A unit used as header values feeds the other sheets of
// its file; its values are changed where they are read, under "Sheets and tables"
// in the file view, never here.
//
// The fields are the unit's own columns, in the base's order, with the values of
// its first sample row (a header-values unit has exactly one row).

import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

function FieldsDialog({ open, unit, onClose }) {
  const firstRow = unit.sample_rows[0] || {};
  const caption = unit.disposition === 'context'
    ? 'Used by the other sheets; not ingested. Change a value under Sheets and tables.'
    : 'Not ingested.';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{unit.name}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{caption}</Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Field</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {unit.columns.length === 0 && (
                <TableRow>
                  <TableCell colSpan={2}>No fields.</TableCell>
                </TableRow>
              )}
              {unit.columns.map((column) => (
                <TableRow key={column}>
                  <TableCell>{column}</TableCell>
                  {/* As text: React draws nothing for a true or false cell. */}
                  <TableCell>{String(firstRow[column] ?? '')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default FieldsDialog;
